<template>
  <div class="content_contact">
    <h3 class="title-text">Your feedback is appreciated</h3>

    <div class="about-right">
      <h3 class="grey push-bottom">We value your opinion.</h3>

      <h4 class="push-bottom">
        Please let us know how we are doing or what we can do to better serve you.
      </h4>

      <p>
        For general inquiry, you can reach us at
        <strong>
          <a href="mailto:info@jeffreyshamburgers.com">info@jeffreyshamburgers.com</a>,
        </strong>
        or use the store specific emails below.
      </p>

      <div class="about_line"></div>

      <div class="about-location-info">
        <div class="about-location">
          <p>42 South B Street</p>

          <p>San Mateo, CA 94401</p>

          <p>Phone : 650.348.8698</p>

          <p>Hours : 11am - 8pm Daily</p>

          <p>
            <strong>
              <a href="mailto:jeffreyssm@jeffreyshamburgers.com">
                jeffreyssm@jeffreyshamburgers.com
              </a>
            </strong>
          </p>

          <div class="line_horizontal"></div>

          <div class="left" style="width:120px;">
            <a href="/locations">Get Directions</a>
          </div>

          <div class="right" style="margin:-3px 0 -7px 0;">
            <a href="/locations">
              <img src="/assets/images/carrot.png" />
            </a>
          </div>

          <div class="line_horizontal"></div>

          <div class="left" style="margin:3px 0 0 42px;">
            <img src="/assets/images/downarrow.png" />
          </div>
        </div>

        <div class="about-location">
          <p>888 El Camino Real</p>

          <p>Menlo Park, CA 94025</p>

          <p>Phone : 650.322.1959</p>

          <p>Hours : 11am - 8pm Daily</p>

          <p>
            <strong>
              <a href="mailto:jeffreysmp@jeffreyshamburgers.com">
                jeffreysmp@jeffreyshamburgers.com
              </a>
            </strong>
          </p>

          <div class="line_horizontal"></div>

          <div class="left" style="width:120px;">
            <a href="/locations">Get Directions</a>
          </div>

          <div class="right" style="margin:-3px 0 -7px 0;">
            <a href="/locations">
              <img src="/assets/images/carrot.png">
            </a>
          </div>

          <div class="line_horizontal"></div>

          <div class="left" style="margin:3px 0 0 42px;">
            <img src="/assets/images/downarrow.png">
          </div>
        </div>
      </div>

      <div style="text-align: center;">
        <img src="/assets/images/jeffreys_icon.png">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
};
</script>
